module.exports = __webpack_public_path__ + "img/1537663492.bdfae900.jpg";